import type { ClipboardEvent } from 'react'
import { pastedList } from './format.ts'

/**
 * Seznam zkopirovany z Messengeru nebo poznamek ma polozky na radcich. Jednoradkove
 * pole by radky slepilo mezerou do jedne polozky — tady se spoji carkou.
 */
export function handleListPaste(e: ClipboardEvent<HTMLInputElement>, setValue: (value: string) => void): void {
  const joined = pastedList(e.clipboardData.getData('text'))
  if (joined === null) return
  e.preventDefault()
  const input = e.currentTarget
  const start = input.selectionStart ?? input.value.length
  const end = input.selectionEnd ?? start
  setValue(input.value.slice(0, start) + joined + input.value.slice(end))
}
